export default __webpack_public_path__ + "static/media/forgetImg.2a493a18.png";